import cn from '../../../utils/cn';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '../Button/Button';

const MoreOrLessButton = ({
  children,
  moreText = 'See more',
  lessText ='See less',
  onClick = null,
  omitDefaultStyles = false,
  className = '',
}) => {
  const [showMore, setShowMore] = useState(false);
  const direction = showMore ? "up" : "down";
  const onButtonClick = (event) => {
    event.preventDefault();
    setShowMore(!showMore);
    if (onClick) {
      onClick();
    }
  };

  const childrenWithFuncs = React.Children.map(children, child => (
    child && React.cloneElement(child, { showMore, showLess: !showMore })
  ));

  const buttonClass = cn(
    {'pl-4 mx-auto text-center flex items-center font-semibold hover:text-deep-blue focus:text-deep-blue': !omitDefaultStyles,
    [className]: className
    },
  );

  return (
    <div>
      {childrenWithFuncs}
      <Button
        id="more-or-less-toggle-btn"
        className={buttonClass}
        link
        onClick={onButtonClick}
        label={`${showMore ? lessText : moreText}`}
        icon={{
          name: 'ChevronArrow',
          color: 'hover:deep-blue',
          position: 'right',
          direction:`${showMore ? 'up' : 'down'}`,
        }} 
        aria-expanded={showMore}
        tabIndex="0"
        aria-controls="more-or-less-content"
        role="button"
      />
    </div>
  );
};

MoreOrLessButton.propTypes = {
  /** Passed children components */
  children: PropTypes.node.isRequired,
  /** Copy for the condensed mode */
  moreText: PropTypes.string,
  /** Copy for the expanded mode */
  lessText: PropTypes.string,
  /** Function to run on click */
  onClick: PropTypes.func,
};

export default MoreOrLessButton;
